export interface RequirementTypeDto {
  RequirementTypeID: string;
  ReqTypeName: string;
  ReqTypeDB: string;
  ReqTypeTable: string;
  ReqTypeColumn: string;
  Notes: string;
  bActive: boolean;
  ComparisonColumn: string;
  RequirementsCount: number;
  DateColumn: string;
  ScoreMethodID: number | null;
  ScoreMethodName: string;
  bHidden: boolean;
}
